/* eslint-disable */
const findWindow = typeof window === 'undefined' ? {} : window

const ensureStructure = window => {
  window.digitalData = window.digitalData || {}
  window.digitalData.page = window.digitalData.page || {}
  window.digitalData.page.lightBox = window.digitalData.page.lightBox || {}
  window.digitalData.page.lightBox.type = window.digitalData.page.lightBox.type || []
  window.digitalData.page.lightBox.clickOrigin = window.digitalData.page.lightBox.clickOrigin || ''
  window.digitalData.page.lightBox.product = window.digitalData.page.lightBox.product || []
  window.digitalData.event = window.digitalData.event || []
  window.digitalData.track = window.digitalData.track || (() => {})
}

//TODO: This function is being called when the sidedrawer closes, firing the event at the wrong time
const onCreditOptionsSlidingPanelOpen = ({ id, price }, trackingOptions, window) => {
  ensureStructure(window)
  window.digitalData.page.lightBox.type = trackingOptions.type
  window.digitalData.page.lightBox.clickOrigin = trackingOptions.clickOrigin
  window.digitalData.page.lightBox.product = [{ id, price }]
  const event = {
    eventInfo: {
      eventName: 'creditBannerLbPage',
      eventAction: 'Credit Quickview Lightbox'
    }
  }
  window.digitalData.event.push(event)
  window.digitalData.track(event.eventInfo.eventName)
}

const onCreditOptionsSlidingPanelShut = window => {
  ensureStructure(window)
  window.digitalData.page = {
    ...window.digitalData.page,
    lightBox: {} //TODO: The lightbox isn't being reset
  }
}

const onAddToTrolleyModalOpen = ({ id, price, quantity }, trackingOptions, window) => {
  ensureStructure(window)
  window.digitalData.page.lightBox.type = 'ATT'
  window.digitalData.page.lightBox.product = [{ id, price, quantity }]

  const event = {
    eventInfo: {
      eventName: 'addToTrolley',
      eventAction: 'Add to Trolley'
    },
    attributes: {
      clickOrigin: trackingOptions.clickOrigin,
      product: [{ id, price, quantity }]
    }
  }
  window.digitalData.event.push(event)
  window.digitalData.track(event.eventInfo.eventName)
}

export { ensureStructure, onCreditOptionsSlidingPanelOpen, onCreditOptionsSlidingPanelShut, onAddToTrolleyModalOpen }
